/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Aoun.Api
 * OpenAPI spec version: 1.0
 */

export type ExportKind = typeof ExportKind[keyof typeof ExportKind];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExportKind = {
  Missions: 'Missions',
  Volunteers: 'Volunteers',
  Participation: 'Participation',
} as const;
